import { store } from "@risingstack/react-easy-state";
import { panelDefaultTitle } from "@/config";
import QboxmailApi from "@/qboxmailApi";
import { isVianovaHost } from "../utils/vianova";
import i18n from "i18next";

const api = new QboxmailApi({ useCookie: true });

// derive initial language from the browser
let browserLang = "en";
if (navigator.languages && navigator.languages[0]) {
  browserLang = navigator.languages[0].match(/it/) ? "it" : "en";
} else if (navigator.language) {
  browserLang = navigator.language.match(/it/) ? "it" : "en";
}

let sessionStore = store({
  // state
  language: browserLang,

  mtmPendingRequests: [],

  customization: undefined,

  applyCustomization(data, persist = true) {
    sessionStore.customization = {
      logo: data.logo,
      company: data.company,
      help_desk_url: data.help_desk_url,
    };

    if (persist) {
      window.localStorage.setItem("qb_customization_company", data.company);
      window.localStorage.setItem("qb_customization_logo", data.logo);
      window.localStorage.setItem("qb_customization_help_desk_url", data.help_desk_url);
    }
  },

  resetCustomization() {
    sessionStore.customization = undefined;

    window.localStorage.removeItem("qb_customization_logo");
    window.localStorage.removeItem("qb_customization_company");
    window.localStorage.removeItem("qb_customization_help_desk_url");
  },

  generatePageTitle() {
    if (isVianovaHost) {
      return `Mail Admin - Vianova`;
    }
    return sessionStore.customization?.company ? `Panel - ${sessionStore.customization.company}` : panelDefaultTitle;
  },

  setSettings({ language, timezone }) {
    if (language) {
      sessionStore.language = language
      i18n.changeLanguage(language)
    };
    if (timezone) sessionStore.timezone = timezone;
  },

  async checkPendingMTMRequests() {
    const pendingRequests = await api
      .getMTMRequestes({
        request_status: "pending",
      })
      .catch((err) => {
        console.log("Error while getting pending MTM requests:");
        console.log(err);
        return null;
      });

    if (!pendingRequests) return;

    sessionStore.mtmPendingRequests = pendingRequests.resources;
  },
});

window.qbSessionStore = sessionStore;

export default sessionStore;
